import FlavorLogo from '@realcity/web-frame/lib/components/Base/FlavorLogo';
import React from 'react';
import { Stack } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';

const AppLogo: React.FC = () => (
    <Box paddingLeft={1}>
        <Stack direction="row" spacing={1} alignItems="center">
            <FlavorLogo
                iconName="logo-square"
                height={48}
            />
            <Typography variant="h5" lineHeight={1}>
                <FormattedMessage id="app.title" />
            </Typography>
        </Stack>
    </Box>
);

export default AppLogo;
